import React, {Component} from 'react';
import {Grid, Col, Row, Button,ControlLabel, FormControl} from 'react-bootstrap';
import classNames from 'classnames';

import Select   from 'react-select'
import config from  '../../../config';
import {prepareSelectOptionsList} from 'util/Utils';
import Datetime from "react-datetime";
import {Link} from "react-router";


export default class AdminFulfillmentSearchBox extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);

        var selectedMarkets = _.isUndefined(this.props.location.query.Markets) ? [ 'Denver' ]: _.map(this.props.location.query.Markets.split(','), function (item) {
          return item
        })

       

        selectedMarkets = _.difference(selectedMarkets,config.allSubMarkets)
console.log('selectedMarkets', selectedMarkets  );

        this.state = {
            filterOptions: {
                perPage: _.isUndefined(this.props.location.query.perPage) ? 30 : this.props.location.query.perPage,
                searchText: _.isUndefined(this.props.location.query.searchText) ? '' : this.props.location.query.searchText,
                Market: _.get(selectedMarkets,0)

            }
        };
    };

    onChangePerPageNumber(option) {
        this.setState({'filterOptions': {...this.state.filterOptions, perPage: option.value}}, function () {
            this.props.search();
        });
    }



    getSearchParams(filtersChanged = {}) {
        var filterOptions = {...this.state.filterOptions, ...filtersChanged};
        console.log('filterOptions', filterOptions);
        var queryParams = {};

            queryParams.perPage = filterOptions.perPage;

        if (filterOptions.searchText !== '') {
            queryParams.searchText = filterOptions.searchText;
        }
        if ( filterOptions.Market ) {
            var Markets = [ filterOptions.Market ]
            var SubMarkets =_.get(config.warehouseData[  filterOptions.Market],'SubMarkets', [])
            if (SubMarkets.length){
                Markets =   _.concat(Markets,SubMarkets)
            }

            queryParams.Markets =  Markets.join(',')
        }
        if (_.get(filterOptions, 'deliveryMethods', []).length ) {
            queryParams.deliveryMethods = _.map(filterOptions.deliveryMethods, 'value')
        }

        if (_.get(filterOptions, 'Statuses', []).length ) {

            queryParams.Statuses = _.map(filterOptions.Statuses, 'value')
        }
        return {queryParams}

    }


    onSearchTextChange(event) {
        var updateOptions = {...this.state.filterOptions, searchText: event.target.value};
        this.setState({'filterOptions': updateOptions})
      //  this.props.search());
    }

    _handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.props.search();
        }
    }

    addOrder(){
        this.props.addOrder()
    }





    render() {
     //   console.log('this.state', this.state  );
          return (
            <div className="product-search-block">
                <Row >
                    <Col md={3} xs={6} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Per Page"
                            clearable={false}
                            options={_.reject(config.perPageSelectOptions, {value:'all'})}
                            onChange={this.onChangePerPageNumber.bind(this)}
                            value={this.state.filterOptions.perPage}
                        />
                    </Col>

                    <Col md={3} xs={6} className="top10">
                        <FormControl type="text"
                                     defaultValue={this.state.filterOptions.searchText}
                                     onKeyPress={this._handleKeyPress.bind(this)}
                                     onChange={this.onSearchTextChange.bind(this)} ref="searchText"
                                     placeholder="Search"/>
                    </Col>

                    <Col md={3} xs={6} className="top10">
                        <button className="btn btn-primary" disabled={this.props.pending} onClick={(event) => this.props.search({page: 1})}
                                type="button">
                            Search
                        </button>
                    </Col>
                </Row>

                <Row className='fulfillment-search-block '>
                    <Col md={3} xs={6} className="top10">
                        <Select
                            tabIndex="0"
                             clearable={false}
                            placeholder="Product location"
                            options={ _.map( _.reject(config.warehouseData, item => {
                              return item.FulfillmentCenter
                            }), item => {
                                return {value: item.MarketName, label: item.MarketName}
                            }) }
                            onChange={ (option) =>{
                                this.setState({'filterOptions': {...this.state.filterOptions, Market:option ? option.value : null}}, function () {
                                    this.props.search();
                                });
                            }}

                            value={this.state.filterOptions.Market}
                        />
                    </Col>
                    {this.props.currentTab == 'ScheduledDeliveries' &&
                    <Col xs={6} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Delivery Method"
                            clearable={true}
                            multi
                            options={[{value: 'GBG', label: 'GBG'}, {value: 'Veho', label: 'Veho'}]}
                            onChange={(selectedOptions) => {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        deliveryMethods: selectedOptions
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                            value={_.get(this.state.filterOptions, 'deliveryMethods', [])}
                        />

                    </Col>
                    }
                    {this.props.currentTab == 'Shipping' &&
                    <Col xs={6} md={3} className="top10">
                        <Select
                            tabIndex="0"
                            placeholder="Status"
                            clearable={true}
                            multi
                            options={[{value: 'Pending', label: 'Pending'}, {value: 'Fulfilled', label: 'Fulfilled'}]}
                            onChange={(selectedOptions) => {
                                this.setState({
                                    'filterOptions': {
                                        ...this.state.filterOptions,
                                        Statuses: selectedOptions
                                    }
                                }, function () {
                                    this.props.search();
                                });
                            }}
                            value={_.get(this.state.filterOptions, 'Statuses', [])}
                        />

                    </Col>
                    }
                </Row>
                <Row>
                    <Col xs={9} sm={6} md={6} lg={3} className="pleft0  top10">
                        <Col xs={12} className="top10">
                            <Button
                              style={_.extend({width: '230px'}, this.props.currentTab == 'DeliverySchedule' ? {borderColor:config.Colors.pink,  backgroundColor:config.Colors.pink}: {  })}
                                    className={classNames('btn btn-lg btn-primary ' )}

                                    onClick={ ()=>this.props.changeTab({currentTab:'DeliverySchedule'})  }>
                                Delivery Schedule Queue
                            </Button>
                        </Col>
                    </Col>
                    <Col xs={9} sm={6} md={6} lg={3} className="pleft0  top10">
                        <Col xs={12} className="top10">
                            <Button   className="btn btn-lg btn-primary"
                                      style={_.extend({width: '230px'}, this.props.currentTab == 'WorkWavePlanning' ? {borderColor:config.Colors.pink,  backgroundColor:config.Colors.pink}: {  })}
                                      onClick={ ()=>this.props.changeTab({currentTab:'WorkWavePlanning'})  }>
                                Workwave Planning
                            </Button>
                        </Col>
                    </Col>
                    <Col xs={9} sm={6} md={6}  lg={3} className="pleft0  top10">
                        <Col xs={12} className="top10">
                            <Button  className="btn  btn-lg btn-primary"
                                    style={_.extend({width: '230px'}, this.props.currentTab == 'ScheduledDeliveries' ?{borderColor:config.Colors.pink,  backgroundColor:config.Colors.pink}: {  })}
                                     onClick={ ()=>this.props.changeTab({currentTab:'ScheduledDeliveries'})  }>
                                Scheduled Deliveries
                            </Button>
                        </Col>
                    </Col>
                    <Col xs={9} sm={6} md={6} lg={3} className="pleft0  top10">
                        <Col xs={12} className="top10">
                            <Button   className="btn btn-lg btn-primary"
                                      style={_.extend({width: '230px'}, this.props.currentTab == 'Shipping' ? {borderColor:config.Colors.pink,  backgroundColor:config.Colors.pink}: {  })}
                                      onClick={ ()=>this.props.changeTab({currentTab:'Shipping'})  }>
                              Shipping
                            </Button>
                        </Col>
                    </Col>
                    <Col md={3} xs={6} className="top20 pull-right">
                        <Button bsStyle="link" className="pull-right">
                            <Link className="pull-right underlineText" onClick={ this.addOrder.bind(this) }>Add Order</Link>
                        </Button>
                    </Col>
                </Row>
            </div>
        );

    }
}



